import { Address } from './common';

export class BankDetail {
    constructor() {
        this.subdomain =null;
        this.IFSCCode = null;
        this.accountNumber = null;
        this.attachedPhoneNumber = null;
        this.name = null;
        this.address = new Address();
        this.type = null;
        this.active = false
        this.charge = 0;
    }
    public subdomain:string;
    public name: string;
    public active: boolean;
    public accountNumber: string;
    public IFSCCode: string;
    public attachedPhoneNumber: string;
    public address: Address;
    public type: string;
    public charge:number;


}